<div class="file-upload-container">
  <mat-icon class="upload-icon">upload</mat-icon>
  <h3>{{ 'file-drop.hint' | translate }}</h3>
  <input type="file" (change)="onFileChange($event)" [multiple]="multiple" [accept]="getAcceptedFileTypes()" />
</div>